import { createContext } from 'react'

import IframeMessageStore from 'stores/IframeMessageStore'

const IframeMessageStoreContext = createContext<IframeMessageStore>(new IframeMessageStore())

export default IframeMessageStoreContext
